import {
    getAvailableScenarios,
    getLatestData
} from "./homeDetailCalculations"

export const getDefaultScenario = (heatLossCalculations: any[]) => {
  const scenarios = getAvailableScenarios(heatLossCalculations)
  if (scenarios.includes("default")) return "default"
  return scenarios[0] || ""
}

export const getOverviewLatestData = (
  heatLossCalculations: any[],
  energyCalculations: any[],
  solarAnalyses: any[]
) => {
  const scenario = getDefaultScenario(heatLossCalculations)
  return getLatestData(
    heatLossCalculations,
    energyCalculations,
    solarAnalyses,
    scenario
  )
}

export const calculateTotalHeatingDemand = (
  latestHeatLoss: any,
  latestEnergy: any
) => {
  if (!latestHeatLoss || !latestEnergy) return 0
  const annualHeatDemand =
    (latestHeatLoss as any)?.totalAnnualHeatDemandKwh || 0
  const cop = parseFloat(latestEnergy.copUsed || "0")
  return cop ? annualHeatDemand / cop : 0
}

export const calculateTotalHouseholdElectricity = (latestEnergy: any) => {
  if (!latestEnergy) return 0
  return (
    parseFloat(latestEnergy.totalElectricityKwh || "0") +
    parseFloat(latestEnergy.totalGasElectrified || "0")
  )
}

export const calculateOverviewNetGridImport = (
  totalHeatingDemand: number,
  totalHouseholdElectricity: number,
  estimatedSolarGen: number
) => totalHeatingDemand + totalHouseholdElectricity - estimatedSolarGen

export const formatOverviewDate = (iso?: string) => {
  if (!iso) return "N/A"
  const date = new Date(iso)
  if (isNaN(date.getTime())) return iso
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric"
  })
}

